var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoneyCancelIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE0A",
    fillRule: "evenodd",
    d: "M1 15.1964V5.5152c0-.7469.8-1.2407 1.5219-1.0438 2.4906.6813 4.9844.0469 7.4781-.5875 2.7188-.6937 5.4375-1.3875 8.1562-.3719.5282.197.8438.7282.8438 1.2907v6.5407c-.9944-1.4138-2.6385-2.3375-4.4983-2.3375a5.48 5.48 0 0 0-2.0514.3956c-.231-1.37-1.2398-2.402-2.4503-2.402-1.3812 0-2.5 1.3438-2.5 3 0 1.3447.7374 2.4834 1.754 2.8643a5.5 5.5 0 0 0-.2481 1.6379c0 .6267.1049 1.2289.298 1.79-2.4867.6232-4.9734 1.1243-7.4601.1954C1.3156 16.2902 1 15.7589 1 15.1964m4-.1968c0-1.1032-.8969-2-2-2v2zm-2-6.5c1.1031 0 2-.897 2-2H3zm14-3.5h-2c0 1.103.8969 2 2 2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE0A",
    d: "M14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-1.4238-5.9238c.1652-.1653.4324-.1653.5959 0l.8261.8261.8262-.8261c.1652-.1653.4324-.1653.5959 0s.1652.4324 0 .5959l-.8262.8261.8262.8262c.1652.1652.1652.4324 0 .5959s-.4324.1652-.5959 0l-.8262-.8262-.8261.8262c-.1653.1652-.4325.1652-.5959 0-.1635-.1652-.1653-.4324 0-.5959l.8261-.8262-.8261-.8261c-.1653-.1653-.1653-.4325 0-.5959"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoneyCancelIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/money-cancel-icon.047d0f8fa4e561e592d3d038cdc22a4c.svg";